import { type CalendarView } from "@repo/api";
import { type RecursivePartial } from "@repo/utils";
import { startOfDay } from "date-fns";

import { type CalenderAppointmentsSearchFilters } from "../calendarFilter/appointmentFilterReducer";

export const getFieldsFromUrl = (
  params: URLSearchParams
): RecursivePartial<CalenderAppointmentsSearchFilters> => {
  const filters = {} as RecursivePartial<CalenderAppointmentsSearchFilters>;
  const tableView =
    (params.get("tableView")?.toString() as CalendarView) ?? "agenda";

  const emailId = params.get("emailId")
    ? params.get("emailId")?.split(",").map(decodeURIComponent)
    : undefined;

  const teamId = params.get("teamId")?.toString();

  if (params.get("tableView") !== null) {
    filters.tableView = tableView;
  }

  if (params.get("emailId") !== null && emailId) {
    if (tableView === "TEAM") {
      if (teamId) {
        filters.teamCalendar = {
          selection: {
            kind: "team",
            teamId: Number(teamId),
            assignedToTeam: false,
            deselectedMemberIds: [],
          },
          emailId: [],
        };
      } else {
        filters.teamCalendar = {
          emailId: emailId,
        };
      }
    } else if (tableView === "OVERVIEW") {
      filters.overviewCalendar = { ...filters.overviewCalendar, emailId };
    } else {
      filters.agendaCalendar = { ...filters.agendaCalendar, emailId };
    }
  }

  if (params.get("teamId") !== null && !filters.teamCalendar) {
    if (tableView === "TEAM") {
      filters.teamCalendar = {
        selection: {
          kind: "team",
          teamId: Number(teamId),
          assignedToTeam: false,
          deselectedMemberIds: [],
        },
        emailId: [],
      };
    }
  }

  filters.selectedDate = params.get("selectedDate")
    ? startOfDay(new Date(Number(params.get("selectedDate"))))
    : startOfDay(new Date());

  return filters;
};
